<template>
  <div class="hotel">
    <loading v-if="isShowLoading"></loading>
    <banner ></banner>
    <div class="hotel_wrap"> 
      <div class="title">
        <img src="./img/hotel-title.png" alt="酒店" />
      </div>
      <div class="dsj"></div>
      <template>
        <div class="hotels">
            <dl v-for="(item,idx) in hotelArr" :key="idx" @click="gotoDetail(item.id)">
              <dt>
                <img  :src="item.mainPic" alt="图片加载失败"/>
              </dt>
              <dd>
                <h3 >{{item.hotelName}}</h3>
                <h5 v-if="item.hotelLevalEnum">{{item.hotelLevalEnum.name}}</h5>
                <div class="info">
                  <div class="info_l" :title="item.detailAddress"><i class="icon_place"></i> {{item.detailAddress}}</div>
                  <div class="info_r">¥<span :style="{fontSize:'20px',margin:'0 5px'}">{{item.lowerPrice}}</span>起</div>
                </div>
              </dd>
            </dl>
            <div class="clearfix"></div>
        </div>
      </template>
    </div>
  
  </div>
</template>

<script>
import banner from './banner'
export default {
  components: {
    banner
  },
  data: function () {
    return {
      token: sessionStorage.getItem("name"),
      isShowLoading: false,
      hotelArr: []
    }
  },
  mounted () {
    this.gethotelList()
    console.log(this.token)
  },
  methods: {
    gethotelList () {
      this.isShowLoading = true;
      let queryUrl = `${this.baseURL}/sys/hotel/v1/shop`
      queryUrl += '?' + this.QS.stringify({
        // access_token: this.token,
        url: window.location.hostname,
        pageNum: 1,
        pageSize: 10,
        orderBy: 'createDate',
        sortIsDown: true
      })
      this.$http.post(queryUrl, { hotelDto: {} }).then(res => {
        let Data = res.data;
        this.isShowLoading = false;
        if (Data.code === 200) {
          let dataArr = Data.data;
          this.hotelArr = dataArr.items
          console.log(dataArr)
        }
      })
    },

    gotoDetail (id) {
      this.$router.push({
        name: 'hotelDetail',
        params: { Id: id }
      })
    },



    /**
       * 景区门票翻页函数
       **/
    async changePage (num) {

      this.page.page = num;
      window.scrollTo(0, 0);
    },


  }
}
</script>
<style lang="less" scoped>
.hotel {
  background-color: #fff;
  .hotel_wrap {
    width: 1220px;
    margin: 0 auto 101px;
    padding: 48px 0 0 0;
    // 图片标题
    .title {
      text-align: center;
      height: 90px;
      padding-bottom: 10px;
      margin-bottom: 8px;
      border-bottom: 1px solid #ececec;
      img {
        height: 86px;
      }
    }
    // 倒三角符号
    .dsj {
      width: 0px;
      height: 0px;
      margin: 0 auto 40px;
      border: 8px solid #4b7ff0;
      border-left-color: transparent;
      border-bottom-color: transparent;
      border-right-color: transparent;
    }
    .hotels {
      overflow: hidden;
      margin-bottom: 32px;
      dl {
        width: 285px;
        float: left;
        margin: 0 10px 20px;
        border-radius: 2px;
        dt {
          height: 160px;
          background-color: #ececec;
          position: relative;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            float: left;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            cursor: pointer;
          }
        }
        dd {
          height: 100px;
          border: 1px solid #ececec;
          border-radius: 2px;
          border-top: 0;
          padding: 12px 0 0 12px;
          h3 {
            font-size: 16px;
            color: #191919;
            letter-spacing: 0.8px;
            text-align: left;
            cursor: pointer;
          }
          h5 {
            font-size: 14px;
            color: #f58931;
          }
          .info {
            overflow: hidden;
            margin-top: 10px;
            line-height: 20px;
            .info_l {
              float: left;
              font-size: 12px;
              color: #99999d;
              width: 160px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              .icon_place {
                display: inline-block;
                width: 15px;
                height: 20px;
                vertical-align: middle;
                background: url("./img/place.svg") no-repeat 2px -2px;
                background-size: 100% 100%;
              }
            }
            .info_r {
              float: right;
              font-size: 14px;
              color: #f4872e;
              margin-right: 18px;
            }
          }
          // p {
          //   overflow: hidden;
          //   font-size: 14px;
          //   color: #ff7f0d;
          //   // padding: 0 12px;
          //   .sp3 {
          //


          //     font-size: 12px;
          //   }
          //   del {
          //     color: #999;
          //     margin-left: 4px;
          //   }
          // }
          // button {
          //   float: right;
          //   width: 88px;
          //   outline: none;
          //   border: 0;
          //   background: #4b7ff0;
          //   border-radius: 2px;
          //   line-height: 32px;
          //   color: #fff;
          //   font-size: 14px;
          //   cursor: pointer;
          // }
        }
      }
    }
    .clearfix {
      display: block;
      content: " ";
      overflow: hidden;
      clear: both;
    }
  }
}
</style>

<style lang="less">
</style>
